import React, { Component } from 'react';
import IgniteDataTable from '../../../../common/datatable';
import { history } from '../../../../../store';

class DamagedBarcodeSubmissionsTable extends Component {
  constructor(props) {
    super(props);

    this.columns = [
      {
        prop: 'created-at',
        title: 'Scan date'
      },
      {
        prop: 'customer-number',
        title: 'Customer number'
      },
      {
        prop: 'user-id',
        title: 'User ID'
      },
    ];

    this.actions = [
      {
        label: 'Review',
        callback: (row) => {
          history.push(`/admin/scans/damaged-barcode-submissions/${row.id}`);
        }
      }
    ];
  }

  render() {
    const {
      scannerCodes, page, handlePageChange, paging
    } = this.props;

    return (
      <IgniteDataTable
        columns={this.columns}
        actions={this.actions}
        data={scannerCodes || []}
        dataSize={paging ? paging.number * paging.size : scannerCodes.length}
        inlineActions
        hideId={false}
        pagination={{
          page,
          sizePerPage: 20,
          onPageChange: handlePageChange,
        }}
        remote
      />
    );
  }
}

export default DamagedBarcodeSubmissionsTable;



// WEBPACK FOOTER //
// ./src/components/admin/scans/damaged-barcode-submissions/list/damaged-barcode-submissions-table.jsx